import Icon from '../../../../baseComponents/gui/icon/Icon';

export default function Beauties({ beauties, price }) {
  return (
    (beauties || price) && (
      <div className={'button__beauties button_transparent custom-button__beauties'}>
        <Icon name={'beauties'} />
      </div>
    )
  );
}
